import { Component, Input, OnInit } from '@angular/core';
import { StudyBundleCourseDto } from '../../../shared/types/StudyBundleCourseDto';
import { StudyBundleCourseStatusType } from '../../../shared/types/StudyBundleCourseStatusType';
import { animate, style, transition, trigger, state } from '@angular/animations';
import QueryParamsUtils from '../../../shared/helpers/query-params-utils';

export enum TileStateType {
  DEFAULT = 'default',
  FLIPPED = 'flipped',
}

@Component({
  selector: 'lp2-mini-lesson-tile',
  templateUrl: './mini-lesson-tile.component.html',
  styleUrls: ['./mini-lesson-tile.component.scss'],
  animations: [
    trigger('cardFlip', [
      state(
        TileStateType.DEFAULT,
        style({
          transform: 'none',
        })
      ),
      state(
        TileStateType.FLIPPED,
        style({
          transform: 'rotateY(180deg)',
        })
      ),
      transition('default => flipped', [animate('200ms')]),
      transition('flipped => default', [animate('200ms')]),
    ]),
  ],
})
export class MiniLessonTileComponent implements OnInit {
  @Input()
  set lessonValue(data: StudyBundleCourseDto) {
    this.lesson = data;
    this.setText(data);
  }
  @Input() inactive: boolean;
  @Input() current: boolean;

  title: string;
  subtitle: string;
  type: string;
  lesson: StudyBundleCourseDto;
  state = TileStateType.DEFAULT;
  studyBundleCourseStatusType = StudyBundleCourseStatusType;

  tmrFlip;

  ngOnInit() {
    // Uncomment to go automatically to the lesson
    // if (this.current) {
    //   console.log('this.current', this.current, this.lesson);
    //   if (this.lesson.type === 'Lesson') {
    //     setTimeout(() => this.openLesson(), 1500);
    //   }
    // }
  }

  cardClicked(autoFlip: boolean) {
    if (this.inactive && this.lesson.status !== StudyBundleCourseStatusType.COMPLETE) {
      if (this.tmrFlip) {
        clearTimeout(this.tmrFlip);
      }

      if (this.state === TileStateType.DEFAULT) {
        this.state = TileStateType.FLIPPED;
      } else {
        this.state = TileStateType.DEFAULT;
      }

      if (autoFlip && this.state === TileStateType.FLIPPED) {
        this.tmrFlip = setTimeout(() => this.cardClicked(false), 10000);
      }
    }
  }

  openLesson() {
    if (!this.inactive || this.lesson.status === StudyBundleCourseStatusType.COMPLETE) {
      const params = QueryParamsUtils.hashQueryParams(`courseId=${this.lesson.id}`);
      window.location.href = `/learning/lesson.html?q=${params}`;
    }
  }

  private setText(data: StudyBundleCourseDto) {
    if (!data) {
      return;
    }
    const splited = data.title.split('|');
    if (data.lessonType === 'AI') {
      this.title = splited[0];
      return;
    }
    [this.title, this.subtitle, this.type] = splited.map((item) => item.trim());
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-tile/mini-lesson-tile.component.ts